<template>
	<div>
		<div
			v-if="message"
			class="notification is-light"
			:class="messageType"
			data-test="form-message"
		>
			{{ message }}
		</div>
		<form v-if="active" @submit.prevent="submit">
			<required-field
				:error="$v.firstname.$error"
				:required="$v.firstname.required"
				label="First name"
			>
				<input
					v-model.trim="$v.firstname.$model"
					class="input"
					type="text"
					:class="{ 'is-danger': $v.firstname.$error }"
					data-test="firstname"
				/>
			</required-field>
			<required-field
				:error="$v.lastname.$error"
				:required="$v.lastname.required"
				label="Surname"
			>
				<input
					v-model.trim="$v.lastname.$model"
					class="input"
					type="text"
					:class="{ 'is-danger': $v.lastname.$error }"
					data-test="lastname"
				/>
			</required-field>
			<required-field
				:error="$v.password.$error"
				:required="$v.password.required"
				label="Password"
			>
				<p class="mb-4">
					Choose a password with eight characters or more. For a strong
					password, use a combination of lowercase and uppercase letters,
					numbers and special characters
				</p>
				<input
					v-model.trim="$v.password.$model"
					class="input"
					type="password"
					:class="{ 'is-danger': $v.password.$error }"
					data-test="password"
				/>
				<p
					v-if="!$v.password.minLength"
					class="help is-danger"
					data-test="password-validation"
				>
					Password must have at least {{ $v.password.$params.minLength.min }}
				</p>
			</required-field>
			<required-field
				:error="$v.repeatPassword.$error"
				:required="$v.repeatPassword.required"
				label="Confirm password"
			>
				<input
					v-model.trim="$v.repeatPassword.$model"
					class="input"
					type="password"
					:class="{ 'is-danger': $v.repeatPassword.$error }"
					data-test="confirm_password"
				/>
				<p
					v-if="!$v.repeatPassword.sameAsPassword"
					class="help is-danger"
					data-test="confirmpassword-validation"
				>
					Passwords must be identical.
				</p>
			</required-field>
			<div class="buttons">
				<button
					class="button is-primary gtm-save"
					:class="{ 'is-loading': fetching }"
					:disabled="!isValid"
					data-test="submit"
				>
					Save password
				</button>
			</div>
		</form>
	</div>
</template>

<script>
import formMixin from "./formMixins";
import { required, minLength, sameAs } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";

export default {
	name: "FormUserInvite",
	mixins: [formMixin],
	validations: {
		firstname: { required },
		lastname: { required },
		password: { required, minLength: minLength(8) },
		repeatPassword: { sameAsPassword: sameAs("password") }
	},
	data() {
		return {
			firstname: "",
			lastname: "",
			password: "",
			repeatPassword: "",
			active: true
		};
	},
	computed: {
		...mapGetters({
			user: "authentication/user"
		}),
		details() {
			const details = {};

			if (!this.$v.password.$invalid) {
				details.firstname = this.firstname;
				details.lastname = this.lastname;
				details.password = this.password;
			}

			return details;
		}
	},
	created() {
		if (this.user) {
			this.firstname = this.user.firstname;
			this.lastname = this.user.lastname;
		}
	},
	methods: {
		async submit() {
			this.$v.$touch();
			if (this.isValid) {
				await this.$emit("submit", this.details);

				this.firstname = "";
				this.lastname = "";
				this.password = "";
				this.repeatPassword = "";
				this.$v.$reset();
			}
		}
	}
};
</script>

<style lang="scss" scoped>
form {
	margin-bottom: 1.5rem;
}
</style>
